import { useTranslation } from 'react-i18next';
import { FeatureType } from '../../../generated/ApiClient';
import { OptionItem } from '../../../component/form/OptionItem';

export const useFeatureTypes = () => {
  const { t } = useTranslation();

  const featureTypes: OptionItem[] = Object.values(FeatureType).map((type) => ({
    value: type,
    label: t(`classification.features.types.${type}`),
  }));

  return { featureTypes };
};
